import React from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

export function QuestionComponent({ onSelect, title, index, userChoice }) {
  const [selected, setSelected] = React.useState(userChoice);
  React.useEffect(() => {
    setSelected(0);
  }, [index]);

  React.useEffect(() => {
    setSelected(userChoice);
  }, [userChoice]);
  return (
    <div className="row">
      <div className="col-12">
        <div className="row">
          <div className="col-12 p-5">
            <Typography variant={"h6"} align={"center"}>
              {index + 1}. {title}
            </Typography>
          </div>
        </div>

        <div className="row mt-4 ">
          <div className="col-12 m-auto text-center">
            <div className="row">
              {[
                "کاملا نادرست",
                "نادرست",
                "نظری ندارم",
                "درست",
                "کاملا درست",
              ].map(
                (item, btnIndex) => {
                  return (
                    <div
                      className={"col-md-2 mx-auto text-center mt-3"}
                      key={`btn-${btnIndex}`}
                    >
                      <Button
                        color={"primary"}
                        className={"shadow-lg w-100"}
                        variant={
                          selected === btnIndex + 1 ? "contained" : "outlined"
                        }
                        onClick={() => {
                          onSelect({
                            value: btnIndex + 1,
                            id: index + 1,
                          });
                          setSelected(btnIndex + 1);
                        }}
                      >
                        {item}
                      </Button>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuestionComponent;
